var SCROLL_BUFFER = 10;

// voice message record
var VOICE_RECORDER_CLICK_BUFFER_TIME = 250;
var VOICE_RECORDER_DEFAULT_MIN = 1000; // 1 seconds
var VOICE_RECORDER_DEFAULT_MAX = 600000; // 10 minutes
var VOICE_RECORDER_AUDIO_BIT_RATE = 12000;
var VOICE_RECORDER_AUDIO_SAMPLE_RATE = 11025;
var BROWSER_SUPPORT_MIME_TYPE_LIST = ['audio/webm', 'audio/mp4', 'audio/mpeg', 'audio/ogg'];

/**
 * Append Audio element to the root
 * because I can't get the Audio element in the useEffect unmount scope
 */
var VOICE_PLAYER_ROOT_ID = 'sendbird-voice-player-provider-root';
var VOICE_PLAYER_AUDIO_ID = 'sendbird-global-audio-player-id';

// voice message file
var VOICE_MESSAGE_FILE_NAME = 'Voice_message.mp3';
var VOICE_MESSAGE_MIME_TYPE = 'audio/mp3;sbu_type=voice';

// meta array
var META_ARRAY_VOICE_DURATION_KEY = 'KEY_VOICE_MESSAGE_DURATION';
var META_ARRAY_MESSAGE_TYPE_KEY = 'KEY_INTERNAL_MESSAGE_TYPE';
var META_ARRAY_MESSAGE_TYPE_VALUE__VOICE = 'voice/mp3';
export { BROWSER_SUPPORT_MIME_TYPE_LIST as B, META_ARRAY_VOICE_DURATION_KEY as M, SCROLL_BUFFER as S, VOICE_RECORDER_DEFAULT_MAX as V, VOICE_RECORDER_DEFAULT_MIN as a, VOICE_MESSAGE_FILE_NAME as b, VOICE_MESSAGE_MIME_TYPE as c, META_ARRAY_MESSAGE_TYPE_KEY as d, META_ARRAY_MESSAGE_TYPE_VALUE__VOICE as e, VOICE_PLAYER_ROOT_ID as f, VOICE_PLAYER_AUDIO_ID as g, VOICE_RECORDER_AUDIO_BIT_RATE as h, VOICE_RECORDER_CLICK_BUFFER_TIME as i, VOICE_RECORDER_AUDIO_SAMPLE_RATE as j };